export enum UnitMeasurementGroupEnum {
  VOLUME = 'VOLUME',
  LENGTH = 'LENGTH',
  MASS = 'MASS'
}
